export const locale = {
    lang: 'ja',
    data: {
        MENU: {
            ACTIONS: 'アクション',
            CREATE_POST: '新しい投稿を作成',
            PAGES: 'ページ',
            FEATURES: '特徴',
            DASHBOARD: 'ダッシュボード',
            PROJECTS: 'プロジェクト一覧',
            RECENT_PROJECTS: '最近のプロジェクト',
            DIRECT_CHAT: 'ダイレクトチャット',
            INFORMATION: 'お知らせ',
            INFORMATION_LIST: 'お知らせ一覧',
            LATEST_UPDATES: '最新のアップデート',
            HOME: 'ホーム',
            CHAT_GROUPS: 'グループチャット',
            FILES: 'ファイル',
            SCHEDULE: 'スケジュール',
            GANTT_CHART: 'スケジュール',
            PROJECT_SETTINGS: 'プロジェクト設定',
            SPACE_MANAGEMENT: 'スペース設定',
            TEAM_MANAGEMENT: 'チーム設定',
            SYSTEM_MANAGEMENT: 'システム設定',
            SPACE_SETTINGS: 'スペースの編集',
            TEAM_SETTINGS: 'チームの編集',
            LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
            USERS: 'ユーザー一覧',
            SPACES: '顧客一覧',
            TEAMS: 'チーム一覧',
            JAPAN_TEAM: '国内',
            JAPAN_TEAM_LIST: '国内チーム一覧',
            OVERSEAS_TEAM: '海外',
            OVERSEAS_TEAM_LIST: '海外チーム一覧',
            MY_SETTINGS: '個人設定',
            USER_INFO: 'ユーザー情報',
            EMAIL: 'メール',
            PASSWORD: 'パスワード',
            ORDER: 'オーダー開始',
            TEAM_ORDER: '新規のプロジェクト',
            PRIVACY_POLICY: 'プライバシーポリシー',
            TERMS_OF_SERVICE: '利用規約',
            COMPANY: 'Order Go! 東京 STUDIO55,Inc. All Rights Reserved.',
            SEARCH_RESULTS: '検索結果一覧',
            CLIENT: '顧客',
            CUSTOMER: '顧客',
            READ_ALL: '全て既読',
            SEARCH_LATEST_CHANGES: "更新履歴検索...",
            // new
            STATUS: "状態",
            ENABLED: "有効",
            DISABLED: "無効",
            NOT_CONFIRMED: "確認待ち",
            SAVE: "保存",
            CREATE: "作成",
        },
        AUTH: {
            GENERAL: {
                OR: 'または',
                SUBMIT_BUTTON: '提出する',
                NO_ACCOUNT: 'アカウントを持っていない？',
                SIGNUP_BUTTON: 'サインアップ',
                FORGOT_BUTTON: 'パスワードをお忘れですか?',
                SAVE_BUTTON: 'パスワード保存',
                BACK_BUTTON: '戻る',
                PRIVACY: 'プライバシー',
                LEGAL: '法的',
                CONTACT: '接触',
                LOGOUT: 'ログアウト',
                // new
                CREATE_NOTIFICATION: 'ユーザーは正常に作成され、一時パスワードを含んだ確認メールが送信されました。',
                SAVE_NOTIFICATION: 'ユーザーは正常に保存されました。'
            },
            LOGIN: {
                TITLE: 'ログイン',
                BUTTON: 'サインイン',
            },
            FORGOT: {
                TITLE: 'パスワードを忘れましたか？',
                DESC: 'パスワードをリセットするためにメールアドレスを入力してください。',
                SUCCESS: 'パスワードのリセットが完了しました。'
            },
            REGISTER: {
                TITLE: '新規登録',
                DESC: 'アカウントを作成するためにユーザー情報を記入してください。',
                SUCCESS: 'アカウントの新規登録が完了しました。'
            },
            INPUT: {
                EMAIL: 'メール',
                FULLNAME: 'フールネーム',
                PASSWORD: 'パスワード',
                CONFIRM_PASSWORD: 'パスワード確認',
                USERNAME: 'ユーザー名'
            },
            VALIDATION: {
                INVALID: '{{name}} は無効な値です',
                REQUIRED: '{{name}} は必須項目です',
                MIN_LENGTH: '{{name}} 最小入力可能文字数は {{min}} です',
                AGREEMENT_REQUIRED: '利用規約の同意が必要です',
                NOT_FOUND: '記入された {{name}} が見つかりません',
                INVALID_LOGIN: 'ログイン情報に誤りがあります',
                REQUIRED_FIELD: '必須項目',
                MIN_LENGTH_FIELD: '最小入力:',
                MAX_LENGTH_FIELD: '最大入力:',
                INVALID_FIELD: '値が正しくありません',
                // new
                CONFIRM_PASSWORD_MUST_MATCH: 'パスワードと確認用のパスワードが一致しません',
            }
        },

        PROJECTS: {
            PROJECTS_LIST: 'プロジェクト一覧',
            PROJECT_HOME: 'プロジェクトホーム',
            LATEST_CHANGES: '最新の更新',
            CHAT_GROUPS: 'グループチャット',
            FILES: 'ファイル',
            SCHEDULE: 'スケジュール',
            GANTT_CHART: 'スケジュール',
            SETTINGS: 'プロジェクト設定',
            DELETE_USER: 'ユーザーの削除',
            EDIT_FILE: 'ファイルの編集',
            DELETE_FILE: 'ファイルの削除',
            DELETE_PROJECT: {
                TITLE: 'プロジェクトを削除',
                DESCRIPTION: 'このプロジェクトを削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'プロジェクトを削除しています...',
                MESSAGE: 'プロジェクトが削除されました。'
            },
            RESTORE_PROJECT: {
                TITLE: 'プロジェクトを復元',
                DESCRIPTION: 'このプロジェクトを復元してもよろしいですか？',
                WAIT_DESCRIPTION: 'プロジェクトを復元しています...',
                MESSAGE: 'プロジェクトが復元されました。'
            },
            DELETE_MULTIPLE_PROJECTS: {
                TITLE: 'プロジェクトを削除',
                DESCRIPTION: 'このプロジェクトを削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'プロジェクトを削除しています...',
                MESSAGE: 'プロジェクトが削除されました。'
            },
            ADD_SCHEDULE_BUTTON: 'スケジュール追加',
            EXPORT_TO_PDF: 'PDFにエクスポート',
            EXPORT_TO_PDF_MOBILE: 'PDF',
            SAVE: '保存',
            CANCEL: 'キャンセル',
            CLOSE: '閉じる',
            DONE: '完了',
            PERMISSION: '許可',
            RESET: 'リセット',
            INFO: 'プロジェクト情報',
            NAME: 'プロジェクト名',
            START_DATE: '着手日',
            SCHEDULED_DELIVERY_DATES: '納品予定日',
            DELIVERY_DATES: '納品日',
            SUB: 'サブ種類選択',
            SUB_TYPE: '種類',
            SUB_TYPE_CAMERA: '項目種類',
            SUB_TYPE_SOFTWARE: 'コンテンツ',
            SUB_TYPE_ANIMATION: '制作秒数',
            USER: 'ユーザー',
            ADD_USER: 'ユーザーの追加',
            PROJECT_NAME_ERROR: 'プロジェクト名が同じではありません。',
            PROJECT_NAME_REQUIRED: 'プロジェクト名が必要です。',
            PROJECT_SEARCH: {
                PROJECT_NAME: 'プロジェクト名',
                FROM_DELIVERY_DATE: '納品日から',
                TO_DELIVERY_DATE: '納品日まで',
                FROM_SCHEDULED_DELIVERY_DATE: '納品予定日から',
                TO_SCHEDULED_DELIVERY_DATE: '納品予定日まで',
                FROM_CREATION_DATE: '作成日から',
                TO_CREATION_DATE: '作成日まで',
                APPLY_FILTERS: '適用する',
                SORT_CATEGORY: '分類カテゴリ',
                SORT_TYPE: 'ソートタイプ',
            },
            SCHEDULED_DATE_OF_DELIVERY: '納品予定日',
            DATE_OF_DELIVERY: '納品日',
            CREATED_BY: '担当者',
            PRICE: '金額',
            MODIFIED_AT: '更新日',
            MENU: 'メニュー',
            COMMENT_ON_DELIVERY: 'コメント欄',
            ADDITIONAL_URLS: '入稿データURL',
            BACK_TO_CHAT_ROOM: 'チャットに戻る'
        },
        PROJECT_MANAGEMENT: {
            ATTACHED_FILES: '添付したファイル',
            MESSAGE_PLACEHOLDER: 'メッセージを入力してください...'
        },
        ZOOM: {
            MEETING: 'ZOOM会議',
            START_MEETING: 'ZOOM会議開始',
            TOPIC: '会議名',
            CANCEL: 'キャンセル',
            CREATE: '作成',
            WAITING: 'このZOOM会議はまだ開始していません。開始しますか？',
            STARTED: 'このZOOM会議は開催中です。参加しますか？',
            ENDED: 'このZOOM会議は既に終了しています。',
            TOPIC_REQUIRED: '会議名が必要です。',
        },
        GENERAL: {
            FORM_ERROR: 'フォーム入力に誤りがあります。確認後もう一度送信してください。',
            DUPLICATE_USER_ERROR: '入力されたメールアドレスは既に登録されています。 別のメールアドレスを使用するか、パスワードの復元サービスを使用してください。',
            DUPLICATE_EMAIL_ERROR: '入力されたメールアドレスは既に登録されています。別のメールアドレスを使用してください。',
            SEARCH: '検索',
            SELECTED_RECORDS_COUNT: '選択ずみ',
            CUSTOMER_SUFFIX: '様',
            CALENDAR_DAY_0: '日',
            CALENDAR_DAY_1: '月',
            CALENDAR_DAY_2: '火',
            CALENDAR_DAY_3: '水',
            CALENDAR_DAY_4: '木',
            CALENDAR_DAY_5: '金',
            CALENDAR_DAY_6: '土',
        },
        SCHEDULES: {
            EDIT_SCHEDULE: {
                UPDATE_MESSAGE: 'タスクが正常に編集されました。',
                ADD_MESSAGE: 'タスクが正常に追加されました。.'
            }
        },
        CONVERSATIONS: {
            ADD_BUTTON: 'グループ追加',
            USER_NAME: 'ユーザー名',
            CONVERSATIONS_LIST: 'グループチャット一覧',
            CONVERSATIONS_HOME: '',
            SUBJECT: '件名',
            SUBJECT_ERROR: '会話の件名が必要です',
            ACTIONS: 'アクション',
            VIEW_CONVERSATION: '',
            EDIT_CONVERSATION: {
                TITLE: 'グループチャット編集',
                UPDATE_MESSAGE: 'グループチャット編集',
                ADD_MESSAGE: 'グループチャット追加'
            },
            DELETE_CONVERSATION: {
                TITLE: 'グループチャット削除',
                DESCRIPTION: 'このグループチャットを削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'グループチャットを削除しています...',
                MESSAGE: 'グループチャットが削除されました。'
            },
            DELETE_PRIVATE_CONVERSATION: {
                TITLE: '個人チャット削除',
                DESCRIPTION: 'この個人チャットを削除してもよろしいですか？',
                WAIT_DESCRIPTION: '個人チャットを削除しています...',
                MESSAGE: '個人チャットが削除されました。'
            },
            MEMBERS: 'グループメンバー',
            PRIVATE_CHAT: '個人チャット',
            PRIVATE_CHAT_REGISTERED: '(登録済み)',
            ADD_USER: '追加ユーザー',
            SYSTEM_MESSAGE: 'システムメッセージ',
            FILE_NAME: 'ファイル名',
            NO_DATA_DESCRIPTION: 'データが見つかりません',
            NEW_ANNOTATION: '新しい注釈がファイルに追加されました',
            CHECK_ESTIMATE_TITLE: 'お見積確認依頼',
            CHECK_ESTIMATE_DESCRIPTION: '上記のお見積金額で宜しいでしょうか？',
            CHECK_ESTIMATE_PENDING: '確認中のお見積',
            CHECK_ESTIMATE_ACCEPT: 'YES',
            CHECK_ESTIMATE_ACCEPTED: 'お見積金額の合意を頂きました。',
            CHECK_ESTIMATE_REJECT: 'NO',
            CHECK_ESTIMATE_REJECTED: '再度お見積内容の検討を致します。',
            FINAL_VERSION_TITLE: '完了確認依頼',
            FINAL_VERSION_DESCRIPTION: '※納品OKにてプロジェクト完了になります。<br />※修正の場合はNOを選択ください。',
            FINAL_VERSION_PENDING: '確認中の納品データ',
            FINAL_VERSION_ACCEPT: 'YES',
            FINAL_VERSION_ACCEPT_MESSAGE: '納品完了致しました。',
            FINAL_VERSION_ACCEPTED: '完了確認依頼受け入れました',
            FINAL_VERSION_REJECT: 'NO',
            FINAL_VERSION_REJECT_MESSAGE: '納品ではありません。',
            FINAL_VERSION_REJECTED: '完了確認依頼拒否されました',
            WITHOUT_AUTOMATIC_TRANSLATIONS: '自動翻訳(無効)',
            WITH_AUTOMATIC_TRANSLATIONS: '自動翻訳(有効)',
            CONVERSATION_NAME: 'グループチャット',
            CREATED_AT: 'アップロード日時',
            FILE_UPLOAD: 'ファイルアップロード',
            LIBRARY: 'ライブラリー',
            CROP_TOOL: '切り抜きツール',
            EMOJI: '絵文字',
            AI_GENERATE: "AI生成",
            ZOOM: 'Zoom',
            AUTO_SCROLL_IS_DISABLED: '自動スクロールが無効になっています',
            CHECK_SCHEDULE: 'スケジュール確認',
            FULL_SIZE_IMAGE_DOWNLOAD: 'フルサイズ画像ダウンロード',
            LITE_SIZE_IMAGE_DOWNLOAD: 'ライト版画像ダウンロード',
            SYSTEM_MESSAGE_CREATE_PROJECT :
                '<p>ORDER GO!より</p>' +
                '<p>ORDER GO!へのご準備ありがとうございます</p>' +
                '<p>担当より本日中にこのチャット上でご連絡させていただきますので今少しお待ちください。</p>' +
                '<p>弊社よりこのチャットから連絡した場合、お客様のORDER GO!登録メールにもアラートが入ります。</p>' +
                '<p class="kt-chat__description">尚オーダー受付時間はAM11:00〜PM8:00となっております。<br />' +
                '本日中のご連絡はオーダー受付時間内のご連絡となりますのでご了承ください。<br />' +
                'オーダー受付時間外の場合には明日のご連絡とさせていただきます。</p>',
            SYSTEM_MESSAGE_CONFIRM_ESTIMATE: '<p>ご発注いただきありがとうございます。</p>' +
                '<p>制作担当ディレクターよりこのチャット上でご連絡させていただきますので今少しお待ちください。</p>' +
                '<p class="kt-chat__description">※弊社よりこのチャットから連絡した場合、お客様のORDER GO!登録メールにもアラートが入ります。</p>',
            SYSTEM_MESSAGE_REJECT_ESTIMATE: '<p>営業担当者より再度連絡させていただきますので、今少しお待ちください。</p>' +
                '<p>弊社よりこのチャットから連絡した場合、お客様のORDER GO!登録メールにもアラートが入ります。</p>' +
                '<p class="kt-chat__description">※営業時間AM11:00〜PM8:00<br />' +
                '※営業時間外の場合には明日中のご連絡となりますのでご了承ください。</p>',
            SYSTEM_MESSAGE_CONFIRM_FINAL_VERSION: '<p>納品確認ありがとうございました。</p>' +
                '<p>本件はこちらで完了となります。</p>' +
                '<p>ご依頼いただきありがとうございました。</p>' +
                '<p class="kt-chat__description">※再度修正がある場合にはお申し付けください。</p>',
            SYSTEM_MESSAGE_REJECT_FINAL_VERSION: '<p>ご確認いただきありがとうございます。</p>' +
                '<p>画像上に再度チェックバックを頂き、制作担当ディレクターよりこのチャット上でご連絡させて頂きますので今少しお待ちください。</p>',
            SYSTEM_MESSAGE_SEND_SCHEDULE: '<p>制作スケジュールを入力致しましたのでご確認ください。</p>' +
                '<p class="kt-chat__description">※チェックバック日程等に不都合がある場合にはお知らせください。</p>',
            SYSTEM_MESSAGE_ADD_ANNOTATION: '<p>チェックバックいただき、ありがとうございました。</p>' +
                '<p>こちらにて制作を進めさせていただきます。</p>' +
                '<p class="kt-chat__description">※修正内容により制作担当ディレクターからご質問させて頂く場合がございます。</p>',
            SYSTEM_MESSAGE_UPLOAD_FILE: '<p>クライアント様が資料をアップされました。</p>',
            SYSTEM_MESSAGE_UPLOAD_ADDITIONAL_FILE: '<p>クライアント様が追加資料をアップされました。</p>',
            SYSTEM_MESSAGE_SUBMIT_ANGLES: '<p>制作チームがアングルを提出しました。</p>',
            SYSTEM_MESSAGE_SELECT_ANGLE: '<p>クライアント様がアングルを選択しました。</p>',
            SYSTEM_MESSAGE_SUBMIT_DRAFT: '<p>制作チームが初稿を提出しました</p>',
            SYSTEM_MESSAGE_SUBMIT_SECOND_DRAFT: '<p>制作チームが修正①を提出しました</p>',
            SYSTEM_MESSAGE_SUBMIT_THIRD_DRAFT: '<p>制作チームが修正②を提出しました</p>',
            SYSTEM_MESSAGE_COPY_DRAFT: '<p>初稿チェック用URLがコピーされました。</p>',
            SYSTEM_MESSAGE_COPY_SECOND_DRAFT: '<p>修正チェック①用URLがコピーされました。</p>',
            SYSTEM_MESSAGE_COPY_THIRD_DRAFT: '<p>修正チェック②用URLがコピーされました。</p>',
            SYSTEM_MESSAGE_SAVE_CHECK_BACK: '<p>チェックバックが保存されました。</p>',
            SYSTEM_MESSAGE_SUBMIT_CHECK_BACK: '<p>クライアント様がチェックバックを提出されました。</p>',
            SYSTEM_MESSAGE_DELIVERY_OK: '<p>クライアント様が納品をOKされました。</p>'
        },
        MESSAGES: {
            SAVE_ANGLE: 'このカメラの既定アングルを今見ているアングルで上書きします。',
            RESTORE_ANGLE: '今見ているアングルをこのカメラの既定アングルに戻します。',
            ADD_ANGLE: '新しいカメラを追加します。',
            DELETE_ANGLE: 'このカメラを削除します。',
            DESCRIPTION_ANGLE_TOOL: '気になるアングルで保存ボタンを押して、コメントしましょう。',
            DELETE_MESSAGE: {
                TITLE: 'メッセージを削除',
                DESCRIPTION: 'このメッセージを削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'メッセージを削除しています...',
                MESSAGE: 'メッセージが削除されました。'
            },
            IMAGE_TOOL: '静止画確認ツール',
            DESCRIPTION_IMAGE_TOOL: '下の画像注釈ツールを使って、気になる部分を強調したりコメントしたりしましょう。',
            ANGLE_REVIEW_TOOL: 'アングル確認ツール'
        },
        MY_SETTINGS: {
            MY_SETTINGS: '個人設定',
            USER_INFO: 'ユーザー情報',
            EMAIL: 'メール',
            PASSWORD: 'パスワード',
            SAVE_PASSWORD: 'パスワード更新',
            SAVE: '保存',
            RESET: 'リセット',
            CREATE_USER: 'ユーザーを作成',
            EDIT_USER: 'ユーザーを編集',
            USER_DETAIL: {
                EMAIL: 'メールアドレス',
                USER_NAME: 'ユーザー名',
                ICON: 'アイコン',
                BACKGROUND_PIC: '背景画像',
                SELECT_IMAGE: '画像を選択',
                LANGUAGE: '言語',
                TIMEZONE: 'タイムゾーン',
                USER_GROUP: '通知グループ',
                USER_GROUP_NAME: '通知グループ名',
                USER_GROUP_NAME_REQUIRED: '通知グループ名は必須です。',
                SELECT_USER_GROUP: '通知グループの選択',
                ROLE: '権限',
                STANDARD_IMAGE: '標準の画像',
                STANDARD_IMAGE_DESCRIPTOPN: 'アイコン選択画面を開く',
                OPEN_BACKGROUND_IMAGE_SELECTION_SCREEN: '背景選択画面を開く',
                ORIGINAL_IMAGE: 'オリジナルの画像',
                ORIGINAL_IMAGE_DESCRIPTOPN: 'ファイルを選択',
                
                IMAGE_DESCRIPTION: 'オリジナル画像のサイズが100x100を超える場合、縮小されます',
                LANGUAGE_DESCRIPTION: 'ユーザの個人設定がある場合、そちらが優先されます。',
                TIMEZONE_DESCRIPTION: '課題の期限切れの判断はこのタイムゾーンの時間を元に行われます。'
            },
            EMAIL_DETAIL: {
                EMAIL: 'メールアドレス：',
                RECIEVE_EMAIL: 'メールを受信する',
                RECIEVE_MYREPORT: 'マイレポートを受信する',
                RECIEVE_SETTINGS: 'メールの件名に「新規」「コメント」「完了」「担当者変更」を含めない',
                RECIEVE_SETTINGS_DESCRIPTION: '（Gmail をご使用の場合、同じ課題に関するメールがひとつのスレッドで表示されるようになります）',
                PROJECT: 'プロジェクトに関するメール：',
                ISSUE: '課題',
                RECEPTION_TIMING: '受信するタイミング',
                LIMIT_ISSUE: '受信する課題を制限する',
                NOTIFICATION: 'お知らせ',
                PROJECT_REPORT: 'プロジェクトレポート',
                ADD: '追加・更新時',
                COMMENT: 'コメント追加時',
                All: '全ての課題を受信',
                CHARGE: '自分が担当',
                REGISTERED: '自分が登録',
                ALWAYS_RECEIVE: '自分宛てのお知らせは必ず受信',
                RECEIVE_PROJECT_REPORT: 'プロジェクトレポートを受信',
                GENERAL_SETTING: '基本設定',
                GENERAL_SETTING_DESCRIPTION: '基本設定 ( 個別の設定がないプロジェクトはこの設定が使われます )'
            },
            DELETE_USER_MODAL: {
                TITLE: 'ユーザー削除',
                DESCRIPTION: 'このユーザーを完全に削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'ユーザーを削除しています...',
                DELETE_MESSAGE: 'ユーザーが削除されました'
            },
            DELETE_TEAM_MODAL: {
                TITLE: 'チームを削除',
                DESCRIPTION: 'このチームを完全に削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'チームを削除しています...',
                DELETE_MESSAGE: 'チームが削除されました。'
            },
            DELETE_SPACE_MODAL: {
                TITLE: '顧客スペースを削除',
                DESCRIPTION: 'この顧客スペースを完全に削除してもよろしいですか？',
                WAIT_DESCRIPTION: '顧客スペースを削除しています...',
                DELETE_MESSAGE: '顧客スペースが削除されました。'
            },
            DELETE_SUUMO_SPACE_MODAL: {
                TITLE: 'SUUMO顧客スペースを削除',
                DESCRIPTION: 'このSUUMO顧客スペースを完全に削除してもよろしいですか？',
                WAIT_DESCRIPTION: 'SUUMO顧客スペースを削除しています...',
                DELETE_MESSAGE: 'SUUMO顧客スペースが削除されました。'
            },
            DELETE_USER_GROUP_MODAL: {
                TITLE: '通知グループを削除',
                DESCRIPTION: 'この通知グループを完全に削除してもよろしいですか？',
                WAIT_DESCRIPTION: '通知グループを削除しています...',
                DELETE_MESSAGE: '通知グループが削除されました。'
            },
            PASSWORD_DETAIL: {
                EMAIL: 'メールアドレス',
                USER_NAME: 'ユーザー名',
                PASSWORD: 'パスワード',
                CURRENT_PASSWORD: '現在のパスワード',
                NEW_PASSWORD: '新しいパスワード',
                CONFIRM_PASSWORD: 'パスワード確認'
            },
            VALIDATION_ERROR_MESSAGE: 'Please fill out the following field(s): {{fields}}'
        },
        SPACE_MANAGEMENT: {
            SPACE_SETTINGS: 'スペース設定',
            CUSTOMER_SETTINGS: '顧客設定',
            SUUMO_CUSTOMER_SETTINGS: '顧客（SUUMO）設定', // new
            SPACE_INFO: 'スペースの編集',
            CUSTOMER_INFO: '顧客の編集',
            SUUMO_CUSTOMER_INFO: '顧客（SUUMO）の編集', // new
            LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
            USERS: 'ユーザー一覧',
            PROJECTS: 'プロジェクト一覧',
            SAVE: '保存',
            RESET: 'リセット',
            BACK: '戻る',
            REQUEST_ADD_USER: 'ユーザー追加依頼',
            ACTIONS: 'アクション',
            EDIT_USER: 'ユーザーの編集',
            DELETE_USER: 'ユーザーの削除',
            EDIT_PROJECT: 'プロジェクトの編集',
            DELETE_PROJECT: 'プロジェクトの削除',
            GENERAL_INFORMATION: '一般情報',
            PASSWORD: 'パスワード',
            SETTINGS_DETAIL: {
                SPACE_NAME: 'スペース名:',
                SPACE_PLACEHOLDER: 'スペース名',
                EDIT_SPACE: 'スペースの編集',
                ADMINISTRATOR: 'STUDIO55 営業担当者',
                CUSTOMER_NAME: '顧客の会社名'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
                LANGUAGE: '言語:',
                LANGUAGE_DESCRIPTION: 'ユーザの個人設定がある場合、そちらが優先されます。',
                TIMEZONE: 'タイムゾーン:',
                TIMEZONE_DESCRIPTION: '課題の期限切れの判断はこのタイムゾーンの時間を元に行われます。',
            },
            USERS_DETAIL: {
                ADD: 'ユーザーを追加',
                USERNAME: 'ユーザー名',
                EMAIL: 'メール',
                AUTHORITY: '権限',
                COMPANY_NAME: '会社名'
            },
            ADD_SPACE_BUTTON_TEXT: '顧客を追加',
            RESET_SPACE_BUTTON_TEXT: 'リセット',
            SAVE_SPACE_BUTTON_TEXT: '保存',
            LIST_OF_SPACE: '顧客一覧',
            LIST_OF_SUUMO_SPACE: '顧客（SUUMO様）一覧',
            LIST_OF_CUSTOMER: '顧客一覧',
            LIST_OF_SUUMO_CUSTOMER: '顧客（SUUMO様）一覧', // new
            LIST_OF_USER_GROUP: '通知グループ一覧',
        },
        TEAM_MANAGEMENT: {
            TEAM_SETTINGS: 'チーム設定',
            TEAM_INFO: 'チームの編集',
            TEAM_NAME: 'チームの名前',
            LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
            SAVE: '保存',
            RESET: 'リセット',
            BACK: '戻る',
            ACTIONS: 'アクション',
            EDIT_USER: 'ユーザーの編集',
            DELETE_USER: 'ユーザーの削除',
            EDIT_TEAM: '編集チーム',
            USERS: 'ユーザー一覧',
            PROJECTS: 'プロジェクト一覧',
            EDIT_PROJECT: 'プロジェクトの編集',
            DELETE_PROJECT: 'プロジェクトの削除',
            GENERAL_INFORMATION: '一般情報',
            PASSWORD: 'パスワード',
            SETTINGS_DETAIL: {
                TEAM_NAME: 'チームの名前',
                TEAM_PLACEHOLDER: 'チームの名前',
                TEAM_TYPE: 'チームの種類'
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
                LANGUAGE: '言語',
                LANGUAGE_DESCRIPTION: 'ユーザの個人設定がある場合、そちらが優先されます。',
                TIMEZONE: 'タイムゾーン',
                TIMEZONE_DESCRIPTION: '課題の期限切れの判断はこのタイムゾーンの時間を元に行われます。',
            },
            USERS_DETAIL: {
                ADD: 'ユーザーを追加',
                USERNAME: 'ユーザー名',
                EMAIL: 'メール',
                AUTHORITY: '権限'
            },
            ADD_TEAM_BUTTON_TEXT: 'チームを追加',
            RESET_TEAM_BUTTON_TEXT: 'リセット',
            SAVE_TEAM_BUTTON_TEXT: '保存',
            LIST_OF_TEAM: 'チーム一覧',
            GANTT_CHART: 'スケジュール'
        },
        SYSTEM_MANAGEMENT: {
            TITLE: 'システム管理',
            TEAMS: 'チーム一覧',
            SPACES: '顧客一覧',
            SYSTEMS: '顧客一覧',
            USERS: 'ユーザー一覧',
            SYSTEM_SETTINGS: 'システム設定',
            SYSTEM_INFO: '顧客の編集',
            USER_GROUP_INFO: '通知グループの編集',
            USER_GROUP_NAME: '通知グループの名前',
            ADD_USER_GROUP: '通知グループを追加',
            USER_GROUP_USERS: '所属ユーザー',
            LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
            PROJECTS: 'プロジェクト一覧',
            SAVE: '保存',
            RESET: 'リセット',
            BACK: '戻る',
            ACTIONS: 'アクション',
            EDIT_USER: 'ユーザーの編集',
            DELETE_USER: 'ユーザーの削除',
            EDIT_PROJECT: 'プロジェクトの編集',
            DELETE_PROJECT: 'プロジェクトの削除',
            RESTORE_PROJECT: 'プロジェクトの復元',
            GENERAL_INFORMATION: '一般情報',
            PASSWORD: 'パスワード',
            COMPANY_NAME: '会社名',
            CUSTOMER_SPACE: '顧客チーム',
            TEAM: 'STUDIO 55 チーム',
            SETTINGS_DETAIL: {
                SPACE_NAME: '顧客名:',
                SPACE_PLACEHOLDER: '顧客名',
                EDIT_SPACE: '顧客の編集',
            },
            LANGUAGE_AND_TIME_SETTINGS_DETAIL: {
                LANGUAGE_AND_TIME_SETTINGS: '言語と時刻の設定',
                LANGUAGE: '言語',
                LANGUAGE_DESCRIPTION: 'ユーザの個人設定がある場合、そちらが優先されます。',
                TIMEZONE: 'タイムゾーン',
                TIMEZONE_DESCRIPTION: '課題の期限切れの判断はこのタイムゾーンの時間を元に行われます。',
            },
            USERS_DETAIL: {
                ADD: 'ユーザーを追加',
                USERNAME: 'ユーザー名',
                EMAIL: 'メール',
                AUTHORITY: '権限'
            },
            ADD_SPACE_BUTTON_TEXT: '顧客を追加',
            RESET_SPACE_BUTTON_TEXT: 'リセット',
            SAVE_SPACE_BUTTON_TEXT: '保存',
            LIST_OF_SPACE: '顧客一覧',
        },
        USER_MANAGEMENT: {
            TITLE: 'システム管理',
            TEAMS: 'チーム一覧',
            SPACES: '顧客一覧',
            USERS: 'ユーザー一覧',
            ADD_USER_BUTTON_TEXT: 'ユーザーを追加',
            BACK_USER_BUTTON_TEXT: '戻る',
            SAVE_USER_BUTTON_TEXT: '保存',
            LIST_OF_USER: 'ユーザー一覧',
        },
        NEW_PROJECT_WIZARD: {
            TITLE: 'オーダー開始',
            SELECT_TYPE: '種類選択',
            SUB_TYPE_SELECTION: '種類選択',
            SUB_TYPE_SELECTION_CAMERA: '項目種類選択',
            SUB_TYPE_SELECTION_SOFTWARE: 'コンテンツ選択',
            SUB_TYPE_SELECTION_ANIMATION: '制作秒数選択',
            REQUIRED: '必須',
            DOCUMENT_UPLOAD: '制作資料アップロード',
            SCHEDULED_DELIVERY_DATES: '納品予定日',
            DELIVERY_DATES: '納品日',
            COMPLETE: 'オーダー準備が完了いたしました',
            SELECT_DESCRIPTION: '以下の種類からお選びください',
            STATUS: '状態',
            PERTH: '静止CGパース',
            CG: '静止CGパース',
            VR: 'VR',
            VRARMR: 'VR・AR・MR',
            BAVR: 'MR (BAVR=Before & After VR)',
            ANIMATION: 'Animation',
            ANIMATION_TIME: '秒数',
            OTHER: 'その他',
            FROM_TIME: 'From Time',
            TO_TIME: 'To Time',
            BIM: 'モデリング.BIM',
            SKETCHUP: 'Sketch Up',
            ENSCAPE: 'WEB VR (Enscape)',
            SHAPESPARK: 'WEB VR (Shapespark)',
            TWINMOTION: 'WEB VR (Twinmotion)',
            FIXED_POINT_PANORAMA: 'VR (定点)',
            UNITY: 'Unity',
            UNREAL: 'Unreal',
            PANORAMA: 'パノラマ写真',
            REVIT: 'Revit',
            ARCHI_CAD: 'Archi CAD',
            IF_CG_IS_SELECTED: '<strong> 静止CGパース 必要資料</strong> <ul>' +
                '<li>アングル指示</li>' +
                '<li> 平面図立面図</li>' +
                '<li> 展開図など（高さ情報が分かるモノ）</li>' +
                '<li> 照明配当図</li><li> 外構図</li>' +
                '<li> 家具や照明等イメージ写真</li>' +
                '<li> 仕上げ情報（マテリアル写真orメーガー品番）</li>' +
                '<li> スケッチ（図面がない場合）</li>' +
                '<li> 仕様書（住宅の場合）</li>' +
                '<li> 配置図</li></ul>',
            IF_CG_IS_SELECTED_BY_SUUMO: '<strong> 静止CGパース 必要資料</strong> <ul>' +
                '<li>平面図（CAD）</li>' +
                '<li> 立体図（CAD）</li>' +
                '<li> 配置図（CAD）</li>' +
                '<li> 外構図（CAD or PDF）</li>' +
                '<li> 仕様書（PDF）</li></ul>',
            IF_VR_IS_SELECTED: '<strong> VR 必要資料</strong> <ul>' +
                '<li>パノラマ写真（BAVRのみ）</li>' +
                '<li> 平面図立面</li>' +
                '<li> 展開図など（高さ情報が分かるモノ）</li>' +
                '<li> 外構情報</li>' +
                '<li> 照明配当図</li>' +
                '<li> 仕上げ情報</li>' +
                '<li> 家具や植栽情報</li>' +
                '<li> 制作範囲</li></ul>',
            IF_ANIMATION_IS_SELECTED: '<strong> アニメーション 必要資料</strong> <ul>' +
                '<li> カメラワーク指示書</li>' +
                '<li> 平面図</li>' +
                '<li> 立面 展開図など（高さ情報が分かるモノ）</li>' +
                '<li> 照明配当図家具や照明等イメージ写真</li>' +
                '<li> 仕上げ情報（マテリアル写真orメーガー品番）</li>' +
                '<li> 制作秒数</li></ul>',
            IF_BIM_IS_SELECTED: '<strong> モデリング BIM 必要資料</strong> <ul>' +
                '<li> 平面図</li>' +
                '<li> 立面 展開図など（高さ情報が分かるモノ）</li>' +
                '<li> 外構情報</li>' +
                '<li> 照明配当図</li>' +
                '<li> 仕上げ情報</li>' +
                '<li> 家具や植栽情報</li></ul>',
            IF_SELECTED: '上記資料が不足の場合でも次へお進みください。<br />資料は後からでもアップロードできます。',
            IF_NOT_SELECTED: '必要なファイルはありません。',
            COMMENT_ON_DELIVERY: 'コメント欄',
            SUB_TYPE_SELECTION_DESCRIPTION1: '以下の項目を選択、記入してください。',
            SUB_TYPE_SELECTION_DESCRIPTION2: 'サブを選んでから、数はフリー入力または「-」、「+」ボタンをクリックしてください。',
            PROJECT_NAME: 'プロジェクト名',
            TYPE: '種類',
            SOFTWARE: 'コンテンツ',
            SHORT_TIME: '0分〜5分',
            MEDIUM_TIME: '5分〜10分',
            LONG_TIME: '10分〜15分',
            APPEARANCE: '外観',
            INSIDE_VIEW: '内観',
            AERIAL_VIEW: '鳥瞰',
            COMMENT: 'コメント',
            DOCUMENT_UPLOAD_DESCRIPTION1: 'ファイルをドロップ、または「ファイルを選択」ボタンからファイルをアップロードしてください。',
            DOCUMENT_UPLOAD_DESCRIPTION2: '※ZIPファイルにて必要なファイルをまとめてください。',
            DOCUMENT_UPLOAD_DESCRIPTION3: 'ここにファイルをドロップ',
            DOCUMENT_UPLOAD_DESCRIPTION4: 'または',
            DOCUMENT_UPLOAD_DESCRIPTION5: 'またはファイルのURLを記入してください',
            DOCUMENT_UPLOAD_DESCRIPTION6: '※ご予約の場合、資料が未完成な場合など、制作資料は後からでもアップロードできます。',
            DOCUMENT_URL_PLACEHOLDER: 'ファイル便をご利用の場合はURLを記入してください',
            CHOICE_FILE: 'ファイルを選択',
            NECESSARY_FILES: ' 必要資料',
            NECESSARY_FILES_DESCRIPTION: 'フォルダーに入っているファイルを以下のリストから必ずチェックしてください。',
            LESS: '以下',
            CAN_UPLOAD: 'アップロードできるファイル',
            CAN_UPLOAD_DESCRIPTION1: 'アップロードするファイルにはパスワードをかけないでください。なお内容に変更、誤りがある場合は再度アップロードしてください。',
            CAN_UPLOAD_DESCRIPTION2: 'ファイル名に「 \ /: * ? " < > | 」を利用することはできません。また、機種に依存した文字を利用した場合、該当の文字を除外したファイル名で登録されます。',
            PREFERRED_DATE: '納品日',
            PREFERRED_TIME: '納品時間',
            START_DATE: '着手日',
            TEN_TO_TWELVE: '10:00 ~ 12:00',
            TWELVE_TO_SIXTEEN: '12:00 ~ 16:00',
            SIXTEEN_TO_NINETEEN: '16:00 ~ 19:00',
            NINETEEN_TO_TWENTYFOUR: '19:00 ~ 24:00',
            TWELVE_TO_SEVENTEEN: '12:00 ~ 17:00',
            SEVENTEEN_TO_TWENTY: '17:00 ~ 20:00',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY_AND_TIME: '着手日、納品日、納品時間をカレンダーからお選びください。',
            ADDITIONAL_DESCRIPTION_ABOUT_DAY: '納品希望日は右よりお選びください。',
            ADDITIONAL_DESCRIPTION_ABOUT_TIME: '希望時間がある場合は納品希望時間よりお選びください。',
            ADDITIONAL_DESCRIPTION_ABOUT_COMMENT: 'その他コメントがある場合にはコメント欄にご記入ください。',
            ADDITIONAL_DESCRIPTION_WARNING: '納品希望日は弊社営業日（平日のみ）から選択できます。土日の納品を希望の場合は、お手数ですが別途コメント欄にご記入ください。',
            ADDITIONAL_DESCRIPTION: '以下の場合は、料⾦や制作期間が異なる場合がございます。 別途ご相談くださいませ。',
            HURRY: 'お急ぎの場合一部図面なし、または写真やスケッチからの制作の場合',
            NIGHT_VIEW: '夕景や夜景をご希望の場合',
            HIGH_QUALITY: 'ハイクオリティをご希望の場合',
            COMPLETE_DESCRIPTION1: 'オーダー準備が完了いたしました。',
            COMPLETE_DESCRIPTION2: '担当より連絡させていただくまでお待ちください。',
            COMPLETE_ADDITIONAL_DESCRIPTION1: '※この時点ではオーダーは開始しておりません。',
            COMPLETE_ADDITIONAL_DESCRIPTION2: '※料金も発生しておりません。',
            BACK: '戻る',
            NEXT: '次へ',
            SAVE: '保存',
            BACK_TO_DASHBOARD: 'ダッシュボードへ戻る',
            DATA_SUBMISSION_CONVERSATION: 'データ入稿',
            PROJECT_PROGRESS_GROUP_CONVERSATION: 'プロジェクト進行グループ',
            DATA_SUBMISSION_MESSAGE: 'データ入稿',
            TIME: 'Time',
            LOGIN_PERMISSION: 'ログイン権限',
            DISABLED: '無効',
            ENABLED: '有効'
        },
        PRIVACY_POLICY: {
            TITLE: '個人情報保護方針',
            OVERVIEW_DESCRIPTION1:
                'STUDIO55,Inc.（以下「当社」といいます）は、お客様が安心して弊社サービスをご利用することができるよう、' +
                '事業活動を通じて取得するお客様の個人情報の保護に細心の注意を払っています。お客様の個人情報を保護することは、' +
                '当社の事業活動の基本であるとともに、当社の社会的責務であると考えております。 ' +
                '当社は責任をもってお客様の個人情報を保護するため、当社が取り扱う個人情報の公正かつ適正な管理、' +
                '運用について規定を定め、社内体制の構築、施策の実施・維持、それらの継続的な改善を行っています。',
            OVERVIEW_DESCRIPTION2:
                '1.　当社は、すべての事業で取扱う個人情報および従業員等の個人情報の取扱いに関し、' +
                '個人情報の保護に関する法律（平成15年法律第57号。以下「法」といいます。）' +
                'その他関連法令、国が定める指針その他の規範を遵守いたします。',
            OVERVIEW_DESCRIPTION3:
                '2.　当社は、「個人情報の取扱い」記載のとおり、個人情報の取得、利用にあたっては、' +
                'その利用目的を特定することとし、特定された利用目的の達成に必要な範囲を超えた個人情報の取扱い' +
                '（目的外利用）はいたしません。また、目的外利用を行わないために、適切な管理措置を講じます。',
            OVERVIEW_DESCRIPTION4:
                '3.　当社は、「個人情報の取扱い」記載のとおり、ご本人の同意を得ている場合、法令にもとづく場合等を除き、' +
                '取得した個人情報を第三者に提供することはいたしません。',
            OVERVIEW_DESCRIPTION5:
                '4.　当社は、個人情報の取扱いに関する苦情および相談を受けた場合は、その内容について迅速に事実関係等を調査し、' +
                '合理的な期間内に誠意をもって対応いたします。',
            OVERVIEW_DESCRIPTION6:
                '5.　当社は、取得した個人情報を適切に管理するため、組織的・人的・物理的・技術的な安全対策措置を講じ、' +
                '個人情報の漏えい、滅失またはき損の防止および是正に取り組みます。',
            OVERVIEW_DESCRIPTION7:
                '6.　当社は、社会情勢・環境の変化を踏まえて、継続的に個人情報保護に関する個人情報保護マネジメントシステムを見直し、' +
                '個人情報保護への取り組みを改善していきます。',
            ESTABLISHMENT: '制定：?年?月?日',
            COMPANY: 'STUDIO55,Inc. 代表取締役社長　?',
            PERSONAL_INFORMATION: '個人情報の取扱い',
            ARTICLE1: '第１条　取得する個人情報',
            ARTICLE1_DESCRIPTION1: '当社は、法に基づき、下記の個人情報を取得いたします',
            ARTICLE1_DESCRIPTION2: '（1） サービスへのログインおよび利用等に関する情報',
            ARTICLE1_DESCRIPTION3: '・サービスログインのためのアカウントのIDおよびパスワード<br>\n' +
                '\t\t\t・アカウント登録情報としての氏名、企業名、電話番号、メールアドレス<br>\n' +
                '\t\t\t・アカウントに紐づく情報としてお客様から提供される氏名、企業名、電話番号、メールアドレス、その他のお客様に関する情報<br>\n' +
                '\t\t\t・サービスの利用を通じてお客様が行った取引の遂行のための情報および当該取引内容に関する情報<br>\n' +
                '\t\t\t・クレジットカード情報、銀行口座情報に関する情報その他の決済およびその方法に関する情報<br>\n' +
                '\t\t\t・サービスの投稿機能を利用してお客様から提供される画像、文章、コメント等の投稿コンテンツに関する情報<br>\n' +
                '\t\t\t・お客様から当社へのお問い合わせやご連絡等に関する情報',
            ARTICLE1_DESCRIPTION4: '（2） お客様が使用する端末に関する情報およびCookie等を利用して取得する情報',
            ARTICLE1_DESCRIPTION5: '・情報通信端末の機体識別に関する情報<br>\n' +
                '\t\t\t・情報通信端末のOS情報<br>\n' +
                '\t\t\t・インターネットへの接続に関する情報<br>\n' +
                '\t\t\t・位置情報<br>\n' +
                '\t\t\t・リファラー情報<br>\n' +
                '\t\t\t・IPアドレス情報<br>\n' +
                '\t\t\t・閲覧したURLおよび閲覧した日時に関するタイムスタンプ情報<br>\n' +
                '\t\t\t・サービスの利用に関する情報<br>\n' +
                '\t\t\t・お客様の端末ごとに割り振られる広告識別子情報<br>\n' +
                '\t\t\t・サーバログ情報',
            ARTICLE1_DESCRIPTION6: '（3） 従業員等に係る情報',
            ARTICLE1_DESCRIPTION7: '・従業員（派遣職員、アルバイトを含みます。）の氏名、住所、来歴その他の従業員に係る情報<br>\n' +
                '\t\t\t・当社の取引先等の個人に係る情報',
            ARTICLE1_DESCRIPTION8: '（4） 第三者から取得する情報',
            ARTICLE1_DESCRIPTION9: '・お客様の同意を得て第三者から取得する情報<br>\n' +
                '\t\t\t・法令に基づき取得する情報<br>\n' +
                '\t\t\t・公開されていることにより取得する情報',
            ARTICLE2: '第２条　個人情報の利用目的',
            ARTICLE2_DESCRIPTION1: '当社は、第１条に記載した個人情報を、法に基づき、下記の目的の範囲内で共同利用いたします。',
            ARTICLE2_DESCRIPTION2: '（1） サービスへのログインおよびサービスの利用',
            ARTICLE2_DESCRIPTION3: '・お客様がサービスにログインするため<br>\n' +
                '\t\t\t・お客様に適したサービスを提供するため<br>\n' +
                '\t\t\t・お客様と当社との間の取引の成立および履行その他のお客様によるサービスの利用のため<br>\n' +
                '\t\t\t・サービスの会員であるお客様の管理のため<br>\n' +
                '\t\t\t・サービスの対価の請求のため<br>\n' +
                '\t\t\t・サービスの運営上必要な事項の通知のため<br>\n' +
                '\t\t\t・サービスの各種問合わせ、アフターサービス対応のため<br>\n' +
                '\t\t\t・退会したお客様へのご連絡・各種問合わせ対応のため<br>\n' +
                '\t\t\t・不正行為等の防止および対応のため',
            ARTICLE2_DESCRIPTION4: '（2） 広告・マーケティング',
            ARTICLE2_DESCRIPTION5: '・サービス上または第三者の媒体においてサービスの勧誘、広告その他のマーケティングをするため\n' +
                '\t\t\t・メールマガジンの送信のため\n' +
                '\t\t\t・ダイレクトメールの送付のため\n' +
                '\t\t\t・キャンペーン、懸賞企画、アンケートの実施のため',
            ARTICLE2_DESCRIPTION6: '（3） 商品開発・研究',
            ARTICLE2_DESCRIPTION7: '・マーケティングデータの調査・分析のため<br>\n' +
                '\t\t\t・当社の新たなサービスや商品等の開発のため',
            ARTICLE2_DESCRIPTION8: '（4） 個人情報保護方針',
            ARTICLE2_DESCRIPTION9: '・採用・労務・退職者その他の当社の労務管理のため<br>\n' +
                '\t\t\t・取引先情報の管理のため',
            ARTICLE3: '第２条　個人情報の利用目的',
            ARTICLE3_DESCRIPTION1: '第３条　個人情報の提供の同意',
            ARTICLE3_DESCRIPTION2:
                '当社は、法令で認められる場合またはお客様の同意をいただいた場合には第三者に対して個人情報を提供いたします。' +
                'ただし、以下の場合においては、当社は第三者に対して、必要な範囲で個人情報（第１号および第２号にあっては，' +
                '氏名や住所など直接特定の個人を識別することができる情報を除外した情報）を提供させていただきます。',
            ARTICLE3_DESCRIPTION3: '（1） サービスの提供または品質向上に必要な場合',
            ARTICLE3_DESCRIPTION4: '（2） 新たなサービスの検討・開発のために必要な場合',
            ARTICLE3_DESCRIPTION6: '（3） 外国にある第三者に個人情報の取り扱いを委託する場合',
            ARTICLE4: '第４条　Order Go!の特則',
            ARTICLE4_DESCRIPTION1: '当社が運営するOrder Go!については、次の規定が適用されます。',
            ARTICLE4_DESCRIPTION2: '（1） お客様の情報の公開',
            ARTICLE4_DESCRIPTION3:
                '① お客様のOrder Go! IDは、Order Go!を提供するウェブサイト上に表示され 全てのお客様に対して公開されることになります。' +
                ' また、お客様が投稿したコンテンツは、Order Go!において 公開設定を行うことにより同じく公開されることになります。',
            ARTICLE4_DESCRIPTION4:
                '② お客様は、Order Go!の機能を利用して、 第三者サイトとOrder Go!とをリンクさせた場合、 ' +
                '第三者サイトにおいてOrder Go!上で公開されている情報全部または 一部が公開されることになります。',
            ARTICLE4_DESCRIPTION5: '③ 当社は、Order Go!の利用を通じた情報の公開に起因してお客様に何らかの損害または損失が発生したとしても、故意または重過失がない限り、当該損害または損失に対し一切の責任を負いません。',
            ARTICLE4_DESCRIPTION6: '（2） サービスの終了と情報の取扱い',
            ARTICLE4_DESCRIPTION7:
                '① お客様がOrder Go!から退会する手続を完了した場合、 または当社がお客様をOrder Go!から退会させた場合、' +
                '当社は、Order Go!上におけるお客様の情報の公開を速やかに停止致します。' +
                'ただし、当該停止時点で既に他のお客様との間でやり取りされたメッセージまたは 共有機能を通して提供されている情報については、 ' +
                '公開停止処理後であっても一部公開状態が継続される可能性があります。',
            ARTICLE4_DESCRIPTION8:
                '② 前項の公開停止後といえども、当社は、関連する適用法令に従い、お客様の情報のアーカイブを正当な事業上の目的のため必要最低限の範囲内において、' +
                '当社の技術上合理的なセキュリティが確保された保管方法にて継続して保有することができるものとします。',
            ARTICLE5: '第６条　開示、訂正等の手続きについて',
            ARTICLE5_DESCRIPTION1: '当社は、ご本人からの開示対象個人情報の開示、利用目的の通知、開示対象個人情報の内容が事実に反する場合等における訂正等、利用停止等および第三者提供の停止（以下「開示等」という。）のご請求を受付いたします。',
            ARTICLE5_DESCRIPTION2: 'https://www.google.com/intl/ja/policies/privacy/partners/',
            ARTICLE6: '第５条　Googleアナリティクスの利用について',
            ARTICLE6_DESCRIPTION1: '当社は、ご本人からの開示対象個人情報の開示、利用目的の通知、開示対象個人情報の内容が事実に反する場合等における訂正等、利用停止等および第三者提供の停止（以下「開示等」という。）のご請求を受付いたします。',
            ARTICLE6_DESCRIPTION2: '（1） 開示等の求めの申し出先',
            ARTICLE6_DESCRIPTION3: '郵送でご請求いただく場合は、第７条の規定の宛先に所定の請求書に必要書類を添付のうえ、ご郵送ください。',
            ARTICLE6_DESCRIPTION4: '（2） ご提出いただくもの',
            ARTICLE6_DESCRIPTION5: '① 個人情報利用目的の通知・開示請求書',
            ARTICLE6_DESCRIPTION6: '② 個人情報訂正等請求書',
            ARTICLE6_DESCRIPTION7: '③ 個人情報利用停止等請求書',
            ARTICLE6_DESCRIPTION8: '④ 本人確認のための書類（運転免許証、パスポートなど）',
            ARTICLE6_DESCRIPTION9: '⑤ 法定代理人の場合は、上記④　に加え、法定代理権があることを確認する書類',
            ARTICLE6_DESCRIPTION10: '（3） 手数料',
            ARTICLE6_DESCRIPTION11:
                '当該ご請求のうち、開示のご請求および利用目的の通知のご請求につきましては、１回のご請求につき、' +
                '1,000円の手数料をご負担いただきますので、あらかじめご了承ください。' +
                'なお、郵送でご請求いただく場合は、振込み等により、手数料をいただきます。' +
                ' 開示等のご請求の具体的な手続きにつきましては、第８条の窓口までお問い合わせください。',
            ARTICLE7: '第７条　個人情報の取扱いに関するご相談・苦情について',
            ARTICLE7_DESCRIPTION11:
                '当社の個人情報の取扱いに関するご相談や苦情等のお問い合わせについては、下記の窓口までご連絡いただきますよう、お願い申し上げます。。',
            CONTACT: '［個人情報についてのお問い合わせ先］<br>\n' +
                '\t\t\t〒???-????<br>\n' +
                '\t\t\t?<br>\n' +
                '\t\t\t?<br>\n' +
                '\t\t\tSTUDIO55,Inc.<br>\n' +
                '\t\t\t営業時間　/　?：?～?：?'
        },
        TERMS_AND_CONDITIONS: {
            TITLE: '利用規約',
            OVERVIEW_DESCRIPTION1:
                '1. STUDIO55,Inc.（以下、「当社」といいます。）は、サービスである「Order Go!」' +
                '（以下、単に「Order Go!」といいます。）、' +
                'その他今後当社が新しく開始するサービス（以下、個別に「各サービス」といいます。）' +
                '及び共通サービスの利用規約（以下、「本規約」といいます。）を以下の通り定めます。',
            OVERVIEW_DESCRIPTION2:
                '2. 各サービスを利用される場合は、各サービスに関する利用規約のみが適用となりますので、' +
                'その場合は当社が別途定める各サービスに関する利用規約にそれぞれ従うものとします。',
            OVERVIEW_DESCRIPTION3: '共通サービス利用規約',
            CHAPTER1: '第1章 総則',
            ARTICLE1: '第1条 本規約の範囲及び変更',
            ARTICLE1_DESCRIPTION1: '1. 本規約は、当社が運営するウェブサイトに共通するサービス（以下、「本サービス」といいます。）の利用に関する規約を定めたものです。',
            ARTICLE1_DESCRIPTION2:
                '2. 本規約は、本サービスの利用に関して、利用者（第3条で定義します。）全てに適用されるものとします。 ' +
                '但し、本サービス以外の当社が提供する各サービスに関して、各サービスに関する利用規約にのみ定めのある規定、' +
                '又は関連する項目で本規約と各サービスに関する利用規約との間で重複する規定がある場合には、' +
                '各サービスに関する利用規約の規定のみが適用されます。',
            ARTICLE1_DESCRIPTION3: '3. 当社は、利用者の事前の承諾を得ることなく、サイト上での掲載又はメール等の当社が適当と判断する方法で利用者に告知又は通知することにより、適宜、本規約の全部又は一部を変更できるものとします。',
            ARTICLE1_DESCRIPTION4: '4. 本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約が適用されるものとし、利用者は変更後の規約のみに従うものとします。',
            ARTICLE1_DESCRIPTION5: '',
            ARTICLE2: '第2条 本サービスの利用',
            ARTICLE2_DESCRIPTION1: '利用者は、法令、規則、通達並びに本規約及び当社が別途定める個人情報保護方針、ヘルプ等に従い、本サービスを利用するものとします。',
            CHAPTER2: '第2章 利用者',
            ARTICLE3: '第3条 利用者',
            ARTICLE3_DESCRIPTION1:
                '本規約において「利用者」とは、本規約の内容を全て了解・承認した上で、当社が本サービスで提供する画像、' +
                'テキスト、デザイン、ロゴ、映像、プログラム、アイディア、情報等（以下、本規約において「コンテンツ」と総称します。）' +
                'を検索、閲覧又は利用する者（会員（＜共通サービス利用規約＞第4条で定義します。）を含みます。）を総称します。',
            CHAPTER3: '第3章 会員',
            ARTICLE4: '第4条 会員',
            ARTICLE4_DESCRIPTION1:
                '本規約において「会員」とは、本規約の内容を全て了解・承認した上で、当社所定の手続に従い会員登録を申請し、' +
                '当社がこれを承認した者、並びに会員登録をおこなわずに、商品購入のたびに当社が別途指定する必要事項を入力し、' +
                '当社がこれを承認した者を総称します。',
            ARTICLE5: '第5条 会員登録',
            ARTICLE5_DESCRIPTION1:
                '1. 会員登録の希望者は、本サービスの会員登録ページから、当社が別途指定する方法に従い、' +
                '氏名、企業名、電話番号、メールアドレス、パスワード、また当社を通じて商品又はサービス' +
                '（以下、「商品等」と総称します。）を購入する際には、住所、氏名、電話番号、企業名を設定・入力の上、会員登録申請を行うものとします。',
            ARTICLE5_DESCRIPTION2: '2. 当社は、第1項に基づく申請に対し、パソコン、タブレット端末並びにスマートフォンからの会員登録の場合、会員登録ボタンを押した時点で会員登録を承認するものとします。',
            ARTICLE5_DESCRIPTION3: '3. 当社は、以下の各号の何れかに該当する場合、当該登録を承認しないものとします。',
            ARTICLE5_DESCRIPTION4:
                '(1) 会員登録の希望者が、過去に当社の提供する何らかのサービスに関する規約' +
                '（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）' +
                'に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE5_DESCRIPTION5:
                '(2) 会員登録の希望者が、過去に当社の提供する何らかのサービスに関する規約' +
                '（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）' +
                'に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE5_DESCRIPTION6:
                '(3) 会員登録の希望者が、過去に当社の提供する何らかのサービス' +
                '（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）' +
                'に関して、料金等（商品等の購入代金を含みますが、これに限りません。以下同様とします。）' +
                'の支払を履行していない場合' +
                '（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、' +
                '又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ARTICLE5_DESCRIPTION7: '(4) 過去に本規約第14条（禁止事項）の行為を行ったことが判明した場合',
            ARTICLE5_DESCRIPTION8: '(5) その他登録を承認することが本サービスの運営・管理上、不適当であると当社が合理的に判断する場合',
            ARTICLE5_DESCRIPTION9: '',
            ARTICLE6: '第6条 登録内容の変更',
            ARTICLE6_DESCRIPTION1: '1. 会員は、当社に登録している事項の全部又は一部に変更が生じた場合には、当社が指定する方法により、すみやかに登録内容を変更するものとします。',
            ARTICLE6_DESCRIPTION2: '2. 当社は、利用者が適宜、変更登録を行わなかったことにより何らかの損害が生じたとしても、一切責任を負わないものとします。',
            ARTICLE7: '第7条 本サービスの利用停止及び会員登録の取消',
            ARTICLE7_DESCRIPTION1: '当社は、会員が以下の各号の何れかに該当する場合、事前に通知することなく、当該会員に対して本サービスの利用停止、会員登録抹消その他当社が適当と考える措置を講ずることができるものとします。',
            ARTICLE7_DESCRIPTION2: '(1) 過去に当社の提供する何らかのサービスに関する規約に違反をしたこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ARTICLE7_DESCRIPTION3: '(2) 登録された内容に虚偽の事項が含まれていることが判明した場合',
            ARTICLE7_DESCRIPTION4:
                '(3) 過去又は現在において、当社の提供する何らかのサービスに関して、' +
                '料金等の支払を履行していない場合（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、' +
                'これに限りません。）、又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行 があったことが判明した場合',
            ARTICLE7_DESCRIPTION5: '(4) 過去に本規約第14条（禁止事項）の行為を行ったことが判明した場合',
            ARTICLE7_DESCRIPTION6: '(5) その他当社が定める何らかの規約（本規約を含みますが、これに限りません。）の規定に違反した場合',
            ARTICLE8: '第8条 退会手続',
            ARTICLE8_DESCRIPTION1:
                '会員は、当社所定の手続を経て、退会することができるものとします。' +
                '契約月が月初となる為、翌月退会される場合は当月中に退会手続きを行ってください。' +
                '（例）５月１日から利用されない場合、４月３０日までに退会手続きを行ってください。' +
                'また、契約期間の途中の解約や利用日数の有無にかかわらず、当社が規定した契約期間分の料金は、全額お支払いいただくものとし、既にお支払いいただいた利用料金がある場合でも当社から会員（契約者）への返金は致しません。',
            ARTICLE9: '第9条 ID及びパスワードの管理',
            ARTICLE9_DESCRIPTION1: '1. 会員は、会員登録等の際に会員自身で設定したメールアドレス及びパスワードを厳重に管理・保管する責任を負うものとします。',
            ARTICLE9_DESCRIPTION2: '2. 会員は、当社の事前の同意がある場合を除き、メールアドレス及びパスワードを第三者に譲渡、売買、承継、貸与、開示又は漏洩してはならないものとします。',
            ARTICLE9_DESCRIPTION3: '3. 会員は、メールアドレス又はパスワードが第三者によって不正に使用されていることが判明した場合には、直ちに当社に連絡するものとし、当社の指示がある場合はそれに従うものとします。',
            ARTICLE9_DESCRIPTION4: '4. 会員は、メールアドレス又はパスワードの管理不十分、使用上の過誤・不手際、第三者の無断使用等に起因する損害につき自ら責任を負うものとし、当社は一切責任を負担しないものとします。',
            ARTICLE10: '第10条 個人情報の利用',
            ARTICLE10_DESCRIPTION1: '本サービスの利用に関連して当社が知り得た会員の個人情報については、当社は別途当社が定める「個人情報保護方針」に従い取り扱うものとします。',
            CHAPTER4: '第4章 サービスの利用',
            ARTICLE11: '第11条 提供するサービス',
            ARTICLE11_DESCRIPTION1: '当社は、本サービスの一部として次のサービスを提供します。',
            ARTICLE11_DESCRIPTION2: '(1) 会員がマイページ（第12条で定義します。）を利用すること',
            ARTICLE11_DESCRIPTION3: '(2) 各サービスを横断して検索すること',
            ARTICLE11_DESCRIPTION4: '(3) 各サービスの情報を閲覧すること',
            ARTICLE11_DESCRIPTION5: '(4) 各サービスからのリンク先を閲覧すること',
            ARTICLE12: '第12条 コンソールの利用',
            ARTICLE12_DESCRIPTION1:
                '会員は、当社所定のコンソールを利用することができます。' +
                'コンソールは、本サービスにログインしているメールアドレスの会員の購入、登録、設定・閲覧機能として、' +
                '会員自身が設定もしくは購入したデバイス、キャラクター、背景、AIサービス、プロフィール、インサイトを設定、登録・閲覧できる機能を提供しています。',
            ARTICLE13: '第13条 免責事項',
            ARTICLE13_DESCRIPTION1:
                '1. 本サービスから他のウェブサイト若しくはリソースへのリンク、' +
                '又は第三者のウェブサイト若しくはリソースから本サービスへのリンクを提供している場合、' +
                '当社は、当該リンク先の内容、利用及びその結果（適法性、有効性、正確性、確実性、安全性、最新性及び完全性を含みますが、' +
                'これらに限られません。）については、いかなる責任も負わないものとします。' +
                'なお、当社は、リンク先のウェブサイト又はリソースの内容が、' +
                '違法又は本サービスの管理・運営上不適切であると合理的に判断した場合には、' +
                '会員に何らの通知を要することなく、当該リンク先を削除することができるものとします。',
            ARTICLE13_DESCRIPTION2:
                '2. 本サービス中に広告（懸賞広告を含みますが、これに限りません。）' +
                '又は宣伝を行っている広告主との取引（懸賞等のプロモーションへの参加を含みますが、これに限りません。）' +
                'がある場合、利用者は、自らの判断と責任により、当該広告主との間で取引を行うものであり、' +
                'これに関して当社は一切責任を負わないものとします。' +
                '商品等の代金の支払、契約条件の決定、保証、担保責任、ライセンスの有無等の取引に関する内容・条件は、' +
                '一切、当社が保証するものではなく、当社は、本サービス中に掲載されている広告又は宣伝を経由して行われる取引に起因して、' +
                '会員に何らかの損害については一切責任を負わないものとします。',
            ARTICLE13_DESCRIPTION3: '3. 当社は、以下の場合に、一時的に本サービスが停止、中止又は変更されたとしても、会員が直接的又は間接的に被った一切の損害、損失、不利益等について、いかなる責任も負わないものとします。',
            ARTICLE13_DESCRIPTION4: '(1) 火災、地震、洪水、落雷、大雪等の天変地異が生じた場合',
            ARTICLE13_DESCRIPTION5: '(2）戦争、内乱、テロ、暴動、騒乱等の社会不安が生じた場合',
            ARTICLE13_DESCRIPTION6: '(3) 当社が契約している電話会社、運送会社又はプロバイダから適切なサービスを受けられなかった場合',
            ARTICLE13_DESCRIPTION7: '(4) 当社が技術的に対応不可能な事由が生じた場合',
            ARTICLE13_DESCRIPTION8: '4. 当社は、会員の登録内容に従い事務を処理することにより、当社の債務を履行し免責されるものとします。',
            ARTICLE13_DESCRIPTION9:
                '5. 会員が、本サービスを利用することにより、他の利用者又は第三者に対して何らかの損害等を与えた場合には、' +
                '当該会員はその責任と費用においてこれを解決し、当社には一切の損害、損失、不利益等を与えないものとします。',
            ARTICLE14: '第14条 禁止事項',
            ARTICLE14_DESCRIPTION1: '利用者は、以下の行為を一切行ってはならないものとします。万一、これに違反して当社又は第三者に損害が生じた場合、当該利用者がその損害を全て賠償する責任を負うものとします。',
            ARTICLE14_DESCRIPTION2: '(1) 他の利用者、他の利用者以外の第三者、若しくは当社に迷惑、不利益若しくは損害を与える行為、又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION3: '(2) 他の利用者、他の利用者以外の第三者、若しくは当社の著作権等の知的財産権、肖像権、人格権、プライバシー権、パブリシティ権その他の権利を侵害する行為又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION4: '(3) 本サービスを商業目的で利用する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION5: '(4) 公序良俗に反する行為その他法令に違反する行為又はそれらのおそれのある行為',
            ARTICLE14_DESCRIPTION6: '(5) 虚偽又は誤解を招くような内容を含む情報を登録する行為',
            ARTICLE14_DESCRIPTION7: '(6) 本サービスを通じて入手したコンテンツを利用者が私的使用の範囲外で使用する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION8: '(7) 他の利用者、又は他の利用者以外の第三者を介して、本サービスを通じて入手したコンテンツを複製、販売、出版、頒布、公開及びこれらに類似する行為（但し、当社が予め認めたものは除きます。）',
            ARTICLE14_DESCRIPTION9: '(8) 他の利用者の個人情報を収集、蓄積又は保存をする行為',
            ARTICLE14_DESCRIPTION10:
                '(9) コンピューターのソフトウェア、ハードウェア、通信機器の機能を妨害、破壊、制限するように設計されたコンピューターウィルス、' +
                'コンピューターコード、ファイル、プログラム等のコンテンツを本サービスにアップロードしたり、メール等の手段で送信したりする行為',
            ARTICLE14_DESCRIPTION11: '(10) 同一会員が複数の会員登録をおこなう行為（パソコン、携帯電話又はスマートフォン何れから複数登録する行為も含むものとします。但し、当社が予め認めたものは除きます。',
            ARTICLE14_DESCRIPTION12: '(11) 過度に商品を返品する行為',
            ARTICLE14_DESCRIPTION13: '(12) その他当社の信用を毀損・失墜させる等の当社が不適当であると合理的に判断する行為',
            ARTICLE15: '第第15条 知的財産権',
            ARTICLE15_DESCRIPTION1: '1. 本サービスを通じて提供されるコンテンツの知的財産権は、全て当社に専属的に帰属するものとします。',
            ARTICLE15_DESCRIPTION2:
                '2. 目的の如何を問わず、当社のコンテンツの無断複製、' +
                '無断転載その他の無断二次利用行為等の国内及び国外の著作権法及びその他の法令により禁止される行為が発見された場合には、' +
                '当社は直ちに法的措置をとるものとします。',
            ARTICLE15_DESCRIPTION3: '3. 本条の規定に違反して第三者との間で何らかの紛争が生じた場合、会員はその責任と費用において、かかる紛争を解決するとともに、当社に何らの損害、損失又は不利益等を与えないものとします。',
            CHAPTER5: '第5章 サービスの運用',
            ARTICLE16: '第16条 情報の管理',
            ARTICLE16_DESCRIPTION1:
                '1. 当社は、その裁量により、当社及び当社と提携するサイトにおいて、' +
                '本サービスに関連して利用者が発信したコンテンツの全部又は一部を自由に利用できるものとします。' +
                '当該コンテンツを利用するにあたり、当社は投稿者に対して一切の支払を必要としないものとします。',
            ARTICLE16_DESCRIPTION2:
                '2. 当社は利用者のアクセス履歴及び利用状況の調査のため、' +
                '又は利用者へのサービス向上のために利用者のアクセス履歴に関する以下の情報を収集します。' +
                'なお、当社が発行するクッキーは効果的な広告配信の目的等に使用し、個人情報の収集やその他の目的には一切使用致しません。',
            ARTICLE16_DESCRIPTION3: '(1) 利用者が本サービスのサーバーにアクセスする際のIPアドレス又は携帯端末の機体識別番号に関する情報',
            ARTICLE16_DESCRIPTION4:
                '(2) 当社が、クッキーの技術（Webブラウザを通じてユーザーのコンピューターに一時的にデータを書き込んで利用者が最後にサイトを訪れた日時、' +
                'そのサイトの訪問回数等を記録保存する技術をいいます。）を通じて取得する利用者のアクセス情報',
            ARTICLE16_DESCRIPTION5: '3. 利用者は、利用者がWebブラウザでクッキーを拒否するための設定を行った場合、本サービスの利用が制限される場合があることを予め了承するものとします。',
            ARTICLE17: '第17条 本サービスの保守',
            ARTICLE17_DESCRIPTION1: '当社は、本サービスの稼動状態を良好に保つため、以下各号の何れかの場合には、 利用者に事前に通知を行うことなく、一時的に本サービスの提供の全部又は一部を停止又は中止することができるものとします。',
            ARTICLE17_DESCRIPTION2: '(1) 本サービス提供のためのコンピューターシステム（以下、「システム」といいます。）の定期保守及び緊急保守の場合',
            ARTICLE17_DESCRIPTION3: '(2) 火災、地震、洪水、落雷、大雪等の天変地異により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION4: '(3) 戦争、内乱、テロ、暴動、騒擾等の社会不安により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION5: '(4) システムの不良及び第三者からの不正アクセス、コンピューターウィルスの感染等により、システムの運用が困難になった場合',
            ARTICLE17_DESCRIPTION6: '(5) 政機関・司法機関から相当な根拠に基づき要請された場合',
            ARTICLE17_DESCRIPTION7: '(6) その他やむを得ずシステムの停止又は中止が必要と当社が判断した場合',
            ARTICLE18: '第18条 その他',
            ARTICLE18_DESCRIPTION1: '1. 本サービスの利用に関して、本規約又は当社の指導・対応により解決できない問題が生じた場合には、当社と利用者との間で双方誠意をもって話し合い、これを解決するものとします。',
            ARTICLE18_DESCRIPTION2: '2. 本サービスの利用に関して訴訟の必要が発生した場合には、名古屋地方裁判所を第一審の専属合意管轄裁判所にするものとします。',
            ARTICLE18_DESCRIPTION3: '付則：本規約は2018年11月21日から全ての利用者に適用されるものとします。',
            ORDERGO_TITLE: 'Order Go!サービス利用規約',
            ORDERGO_CHAPTER1: '第1章 総則',
            ORDERGO_ARTICLE1: '第1条 本規約の範囲及び変更',
            ORDERGO_ARTICLE1_DESCRIPTION1:
                '1. この規約（以下、「本規約」といいます。）は、' +
                '当社が運営するウェブサイト「Order Go!」に関するサービス' +
                '（以下、「本サービス」といいます。）の利用に関し、当社及び会員（第3条で定義します。）に適用されるものとします。' +
                '但し、本サービス以外に当社が提供する各サービスに関しては、当該各サービスに関連する利用規約のみが適用されるものとします。',
            ORDERGO_ARTICLE1_DESCRIPTION2:
                '2. 当社は、会員の事前の承諾を得ることなく、' +
                'ウェブサイト上での掲載又はメール等の当社が適当と判断する方法で会員に告知又は通知することにより、' +
                '適宜、本規約の全部又は一部を変更できるものとします。',
            ORDERGO_ARTICLE1_DESCRIPTION3: '3. 本規約の全部又は一部が変更された場合、本サービスの利用に関しては、変更後の規約のみが適用されるものとし、会員は変更後の規約のみに従うものとします。',
            ORDERGO_ARTICLE2: '第2条 本サービスの利用',
            ORDERGO_ARTICLE2_DESCRIPTION1: '1. 会員は、法令、条例、規則、通達並びに共通サービス利用規約、本規約及び当社が別途定める個人情報保護方針、ヘルプ等に従い、本サービスを利用するものとします。',
            ORDERGO_ARTICLE2_DESCRIPTION2: '2. 未成年の会員は、適格な法定代理人の事前の同意を得なければ、本サービスを利用することができません。',
            ORDERGO_ARTICLE3: '第3条 提供するサービス',
            ORDERGO_ARTICLE3_DESCRIPTION1: '利用者は、本サービスにおいて次の行為を行うことができます。',
            ORDERGO_ARTICLE3_DESCRIPTION2: '(1) 会員は、当社所定の方法に従い、本サービスを利用して当社から商品等を購入する、キャラクター、背景、AIサービス等の設定をすることができます。',
            ORDERGO_CHAPTER2: '第2章 会員',
            ORDERGO_ARTICLE4: '第4条 会員',
            ORDERGO_ARTICLE4_DESCRIPTION1: '本規約において「会員」とは、当社が別途定める＜共通サービス利用規約＞「第4条 会員」の規定が適用されるものとします。',
            ORDERGO_ARTICLE5: '第5条 会員登録',
            ORDERGO_ARTICLE5_DESCRIPTION1: '1. 会員登録をする際には、＜共通サービス利用規約＞「第5条 会員登録」に定めた会員登録に必要な項目を入力・設定した上で、登録申請することを前提条件とします。',
            ORDERGO_ARTICLE5_DESCRIPTION2: '2. 未成年者は、適格な法定代理人の事前の同意がなければ、会員登録申請をすることができないものとします。',
            ORDERGO_ARTICLE5_DESCRIPTION3: '3. 当社は、以下の各号の何れかに該当する場合、当該登録を承認しない場合があります。',
            ORDERGO_ARTICLE5_DESCRIPTION4:
                '(1)会員登録の希望者が過去に当社の提供する何らかのサービスに関する規約' +
                '（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）' +
                'に違反したこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION5: '(2)会員登録の希望者の申請内容に虚偽の事項が含まれていることが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION6:
                '(3)過去に当社の提供する何らかのサービス（サイト上に明記した各サービスに関連する他社のサービスを含みますが、' +
                'これらに限りません。）に関して、料金等の支払を履行していない場合' +
                '（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、' +
                '又は、正当な理由なく長期間に亘る商品又はサービス（以下、「商品等」と総称します。）' +
                'の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION7: '(4)過去に＜共通サービス利用規約＞「第14条 禁止事項」の行為を行ったことが判明した場合',
            ORDERGO_ARTICLE5_DESCRIPTION8: '(5)その他登録を承認することが本サービスの運営・管理上、不適当であると当社が合理的に判断する場合',
            ORDERGO_ARTICLE6: '第6条 登録内容の変更',
            ORDERGO_ARTICLE6_DESCRIPTION1: '1. 会員は、氏名、住所、電話番号その他当社に登録している事項の全部又は一部に変更が生じた場合には、当社が指定する方法により、すみやかに登録内容を変更するものとします。',
            ORDERGO_ARTICLE6_DESCRIPTION2: '2. 当社は、会員が適宜、変更登録を行わなかったことにより何らかの損害が生じたとしても、一切責任を負わないものとします。',
            ORDERGO_ARTICLE7: '第7条 本サービスの利用停止及び会員登録の取消',
            ORDERGO_ARTICLE7_DESCRIPTION1: '当社は、会員が以下の各号の何れかに該当する場合、事前通知することなく、当該会員に対して本サービスの利用停止、会員登録抹消その他当社が適当と考える措置を講ずることができるものとします。',
            ORDERGO_ARTICLE7_DESCRIPTION2:
                '(1)過去に当社の提供する何らかのサービスに関する規約' +
                '（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）' +
                'に違反をしたこと等により、会員登録の抹消等の処分を受けていたことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION3: '(2)登録された内容に虚偽の事項が含まれていることが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION4:
                '(3)過去又は現在において、当社の提供する何らかのサービス' +
                '（サイト上に明記した各サービスに関連する他社のサービスを含みますが、これらに限りません。）' +
                'に関して、料金等の支払を履行していない場合' +
                '（当社が別途認める支払方法に関連する第三者に対して料金等の支払を履行していない場合を含みますが、これに限りません。）、' +
                '又は、正当な理由なく長期間に亘る商品等の受取り不能、返品・交換の拒絶その他の債務不履行があったことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION5: '(4)＜共通サービス利用規約＞「第14条禁止事項」の行為を行ったことが判明した場合',
            ORDERGO_ARTICLE7_DESCRIPTION6: '(5)その他当社の定める何らかの規約（本規約及びサイト上に明記した各サービスに関連する他社の規約を含みますが、これらに限りません。）に違反した場合',
            ORDERGO_ARTICLE8: '第8条 退会手続',
            ORDERGO_ARTICLE8_DESCRIPTION1: '退会を希望する場合は、別途定める＜共通サービス利用規約＞「第8条 退会手続」の規定が適用されるものとします。',
            ORDERGO_CHAPTER3: '第3章 商品の購入',
            ORDERGO_ARTICLE9: '第9条 商品の購入',
            ORDERGO_ARTICLE9_DESCRIPTION1: '1. 会員は、商品等の購入を希望する場合、当社が別途指定する方法に従って、商品等の購入又は利用を申込むものとします。',
            ORDERGO_ARTICLE9_DESCRIPTION2:
                '2. 前項の申込みに伴い、会員が入力・登録した注文内容等を確認の上で注文する旨のボタンをクリックし、' +
                'その後、当社から注文内容を確認する旨のメールが会員に到達した時点で、' +
                '会員と当社との間に当該商品等に関する売買契約が成立するものとします。',
            ORDERGO_ARTICLE9_DESCRIPTION3: '3. 前項の規定に拘わらず、本サービス利用に関して不正行為又は不適当な行為があった場合、当社は売買契約について取消、解除その他の適切な措置を取ることができるものとします。',
            ORDERGO_ARTICLE10: '第10条 支払方法',
            ORDERGO_ARTICLE10_DESCRIPTION1: '1. 商品等の支払い金額は、消費税を含む商品等の購入代金及びこれに係わる取り扱い手数料の合計となります。',
            ORDERGO_ARTICLE10_DESCRIPTION2: '2. 本サービスによって購入された商品等の支払いに関しては、会員本人名義のクレジットカードによる支払、又は当社が別途認める支払方法に限るものとします。',
            ORDERGO_ARTICLE10_DESCRIPTION3:
                '3. クレジットカードで支払われる場合は、会員がクレジットカード会社との間で別途契約する条件に従うものとします。' +
                'なお、クレジットカードの利用に関連して、会員とクレジットカード会社等の間で何らかの紛争が発生した場合は、' +
                '会員とクレジットカード会社との間で責任をもって解決するものとします。',
            ORDERGO_ARTICLE11: '第11条 商品等の返品・交換・注文の撤回及び取消し',
            ORDERGO_ARTICLE11_DESCRIPTION1: '1.ご注文の撤回及び取消しについては、当社の責めに帰すべき事由がある場合を除き、商品のご注文の撤回および取消しをすることができません。',
            ORDERGO_ARTICLE11_DESCRIPTION2: '2.商品の返品については、以下の場合に限り受け付けるものとします。',
            ORDERGO_ARTICLE11_DESCRIPTION3: '(1)商品が模造品・海賊版であることが判明した場合',
            ORDERGO_ARTICLE11_DESCRIPTION4: '(2)商品に瑕疵があった場合',
            ORDERGO_ARTICLE12: '第12条 商品等に関する免責',
            ORDERGO_ARTICLE12_DESCRIPTION1:
                '1.当社は、本サービス及び本サービスを通じて販売される商品等につき、その品質、材質、機能、性能、プログラム、' +
                '他の商品との適合性その他の欠陥、又はこれらが原因となり生じた損害、損失、不利益等については、前条に定める場合を除き、' +
                'いかなる保証・負担も負わないものとします。',
            ORDERGO_ARTICLE12_DESCRIPTION2:
                '2.当社は、Order Go!のすべてのサービス及びトップページ及び販売ページ上において、' +
                'Twitter等のSNSサービスの利用会員が投稿した商品及び設定に関するコメントの内容について、' +
                '当該コメントの内容が事実に反するものであったとしても、これによる商品を購入した会員に生じた損害に対しては、' +
                '当社に故意又は重過失がある場合を除き、一切の責任を負わないものとします。',
            ORDERGO_ARTICLE12_DESCRIPTION3: '付則：本規約は2018年11月29日から全ての会員に適用されるものとします。',
        },
        LATEST_CHANGES: {
            ADD_PROJECT: '{{projectName}} - {{fullname}}さんが新しいプロジェクトを追加しました',
            UPDATE_PROJECT: '{{projectName}} - {{fullname}}さんがプロジェクトを更新しました',
            UPDATE_PROJECT_BY_CLIENT: '{{projectName}} - {{fullname}}様がプロジェクトを更新しました',
            DELETE_PROJECT: '{{projectName}} - {{fullname}}さんがプロジェクトを削除しました',
            ADD_CONVERSATION: '{{projectName}} - {{fullname}}さんが新しいグループチャットを追加しました',
            UPDATE_CONVERSATION: '{{projectName}} - {{fullname}}さんがグループチャットを更新しました',
            DELETE_CONVERSATION: '{{projectName}} - {{fullname}}さんがグループチャットを削除しました',
            ADD_MESSAGE: '{{projectName}} - {{fullname}}さんが新しいメッセージを追加しました',
            UPDATE_MESSAGE: '{{projectName}} - {{fullname}}さんがメッセージを更新しました',
            DELETE_MESSAGE: '{{projectName}} - {{fullname}}さんがメッセージを削除しました',
            UNREAD: '未読'
        },
        GANTT_CHART: {
            TITLE: 'スケジュール',
            SEND_SCHEDULE_BUTTON: 'スケジュール送信',
            SEND_SCHEDULE_BUTTON_MOBILE: '送信',
            ADD_TASK_BUTTON: 'タスク追加',
            ADD_TASK_BUTTON_MOBILE: 'タスク',
            UPDATE_TASK: 'タスク編集',
            ADD_TASK: 'タスク追加',
            SUBJECT: 'タスク名',
            SUBJECT_ERROR: 'タスク名エラー',
            FROM_DATE: '開始日',
            FROM_DATE_ERROR: '開始日エラー',
            TO_DATE: 'リリース日',
            TO_DATE_ERROR: 'リリース日エラー',
            COLOR: '色',
            RED_COLOR: '赤',
            BLUE_COLOR: '青',
            PRIORITY: '優先度'
        },
        LIBRARY: {
            TITLE: 'ライブラリー',
            FILE_NAME: 'ファイル名',
            ADD: '送信',
            EDIT: '編集',
            DELETE: '削除',
            TAGS: 'タグ',
            ADD_NEW_TAG: 'タグ追加',
            SEARCH_BY_TAGS: 'タグで検索',
            SEARCH_BY_MATERIAL: '材料から検索',
            SEARCH_BY_COLOR: '色から検索',
            UPLOAD_FILE_FROM_OUTSIDE: 'ファイルアップロード',
            SELECT_TAGS: 'タグを選択',
            SELECT_COLORS: '色を選択',
            LIST_OF_MATERIALS: '材料一覧'
        },
        PUSH_NOTIFICATION: {
            PROJECT_MODIFIED_TITLE: '変更されたプロジェクト',
            PROJECT_MODIFIED_BODY: '{{fullname}}は{{name}}プロジェクトを変更しました。',
            CONVERSATION_MODIFIED_TITLE: 'チャットグループの変更',
            CONVERSATION_MODIFIED_BODY: '{{fullname}}が{{name}}チャットグループを変更しました。',
            MESSAGE_ADDED_TITLE: '新しいメッセージ',
            MESSAGE_ADDED_BODY: '{{fullname}}が{{name}}に新しいメッセージを送信しました',
            DIRECT_MESSAGE_ADDED_BODY: '{{fullname}}から新しいメッセージが受信されました',
            NOTIFICATION_TITLE: '通知',
            NOTIFICATION_TEXT: '通知があなたを待っています。'
        },
        FILE_ANNOTATIONS: {
            RECTANGLE_TOOL: '長方形ツール',
            CIRCLE_TOOL: '円ツール',
            ARROW_TOOL: '矢印ツール',
            POLYGON_TOOL: '多角形ツール',
            PAINT_TOOL: 'ペイントツール',
            ANNOTATION_TOOL: '注釈ツール',
            SAVE_AND_SEND: '保存して送信',
            SAVE_AND_CLOSE: '保存して閉じる',
            CLOSE_WITHOUT_SAVE: '保存せずに閉じる',
            ANGLE: "アングル",
            SAVE: "保存",
            ADD: "追加",
            RESTORE: '復元',
            ADD_COMMENT: "コメント追加",
            PERSPECTIVE_CORRECTION: "歪み補正",
            DOWNLOAD_ANNOTATED_IMAGE: "注釈画像ダウンロード",
            DOWNLOAD_ORIGINAL_IMAGE: "元画像ダウンロード",
            DELETE: '削除',
            UNDO: '元に戻す',
            REDO: 'やり直す',
            RESIZE: 'サイズ変更',
            DOWNLOAD: 'ダウンロード',
            DISPLAY_HORIZONTAL: '水平表示',
            DISPLAY_VERTICAL: '垂直表示',
            // TODO <h6>や<h4>を文字の大きさの指定のために使ってはいけません！
            DESCRIPTION : '<h6>こちらから直接チェックバックを行うことが可能です。</h6><h6>※図に番号を振っていただき、コメントを入れてください。</h6><h6>※図形や矢印も入力できます。</h6>',
            SUUMO_DESCRIPTION : '<h6>**このファイルへのコメントはSUUMO GO!のお客様からは見えません。</h6>',
            DESCRIPTION2 : '<h6>こちらから直接チェックバックを行うことが可能です。</h6><h6>※図に番号を振っていただき、コメントしてください。</h6>',
            DESCRIPTION3: '<h6>修正内容がSUUMOへ提出されました。修正内容の提出後、修正等の対応は行えません。</h6><h6>後日、修正した外観パース画像をご送付いたしますのでお待ちください。</h6>',
            DESCRIPTION4: '<h6>外観パース画像が完成いたしました。完成後は、修正等の対応は行えません。</h6>',
            DESCRIPTION5: '<h4>アングル確定後にアングル変更は行えません。<h4>',
            DESCRIPTION6: '<h4>このプロジェクトは削除されています。<h4>',
        }
    }
};
